"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    InfoLabel: function() {
        return _InfoLabel.InfoLabel;
    },
    infoLabelClassNames: function() {
        return _InfoLabel.infoLabelClassNames;
    },
    renderInfoLabel_unstable: function() {
        return _InfoLabel.renderInfoLabel_unstable;
    },
    useInfoLabelStyles_unstable: function() {
        return _InfoLabel.useInfoLabelStyles_unstable;
    },
    useInfoLabel_unstable: function() {
        return _InfoLabel.useInfoLabel_unstable;
    }
});
const _InfoLabel = require("./InfoLabel");
